@if (absence.absenteeOption?.icon; as icon) {
  <sb-icon class="shrink-0" [name]="icon" size="lg" />
}
@if (!compactView) {
  <div class="min-w-0 flex-1">
    <div class="truncate text-sm leading-none font-bold">
      @if (absence.AbsenteeDay[date].partial_day) {
        {{ absence.AbsenteeDay[date].startTime | time }} - {{ absence.AbsenteeDay[date].endTime | time }}
      }
      {{ absence.absenteeOption?.option }}
    </div>
    @if (mode === 'team') {
      <div class="mt-0.5 truncate text-xs leading-tight" data-hj-suppress>
        {{ absence.Employee?.name }}
      </div>
    }
  </div>
}
